import { Checkbox, CityState, DataSource, HorizontalSpacer, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOptionalSettings extends Layout {
    checkboxAllowIncInFrt: Checkbox;
    checkboxBrokerageFilter: Checkbox;
    checkboxIsGeocoded: Checkbox;
    checkboxManualExchange: Checkbox;
    checkboxPostSummaryDtl: Checkbox;
    checkboxVmPartUpdate: Checkbox;
    citystate1: CityState;
    horizontalspacer11: HorizontalSpacer;
    horizontalspacer12: HorizontalSpacer;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    horizontalspacer4: HorizontalSpacer;
    horizontalspacer5: HorizontalSpacer;
    horizontalspacer6: HorizontalSpacer;
    horizontalspacer7: HorizontalSpacer;
    horizontalspacer8: HorizontalSpacer;
    horizontalspacer9: HorizontalSpacer;
    panelOptionalSettings: Panel;
    sourceCustomer: DataSource;
    textboxBillDueDays: Textbox;
    textboxCustRequestorLoadId: Textbox;
    textboxFourkitesCustomerId: Textbox;
    textboxGooglePlaceId: Textbox;
    textboxIntegrationType: Textbox;
    textboxLatitude: Textbox;
    textboxLongitude: Textbox;
    textboxMacropointRequestorId: Textbox;
    textboxMonthlyOrderGoal: Textbox;
    textboxSummaryBilling: Textbox;
    textboxTrimblePlaceId: Textbox;
}
